import { ReadonlyURLSearchParams, useSearchParams } from "next/navigation";
import Pager from "./Pager";
/*import "./Pagination.scss";*/
import { ReactNode } from "react";

const VALUES = [
  <i className="fa fa-arrow-left" />,
  <i className="fa fa-chevron-left" />,
  "",
  <i className="fa fa-chevron-right" />,
  <i className="fa fa-arrow-right" />,
];

function generatePagers(
  current: number,
  max: number,
  searchParams: ReadonlyURLSearchParams,
) {
  const search = searchParams.toString();
  const pages = [-current, -1, 0, 1, max - current].map((v) =>
    Math.max(1, Math.min(max, v + current)),
  );

  const pagers: ReactNode[] = [];

  pages.forEach((v, i) => {
    const value = i === 2 ? v.toString() : VALUES[i];

    pagers.push(
      <Pager
        key={i}
        to={`/blog/${v}${search}`}
        value={i === 2 ? `${value} / ${max}` : value}
        active={i === 2}
      />,
    );
  });

  return pagers;
}

const Pagination = ({ currentPage, totalPages }: PaginationProps) => {
  const search = useSearchParams();
  const pagers = generatePagers(currentPage, totalPages, search);

  if (totalPages < 2) {
    return <></>;
  }

  return (
    <div className="row mt-4">
      <div className="col-12">
        <nav aria-label="Blog pagination" className="Pagination">
          <ul className="pagination pagination-lg justify-content-center">
            {pagers}
          </ul>
        </nav>
      </div>
    </div>
  );
};

interface PaginationProps {
  currentPage: number;
  totalPages: number;
}

export default Pagination;
